import { useRouter } from 'next/router';

export const useSpaceIDFromPath = (): string => {
  const router = useRouter();
  const { space_id: spaceID } = router.query;

  return spaceID as string;
};

// useSpaceAndPageIDFromRouter returns [spaceID, pageID]
// NOTE THE RETURN ORDER
export const useSpaceAndPageIDFromRouter = (): Array<string> => {
  const router = useRouter();
  const { space_id: spaceID, page_id: pageID } = router.query;

  return [spaceID as string, pageID as string];
};

export const useAIPageIDFromPath = (): string => {
  const router = useRouter();
  const { ai_page_id: aiPageID } = router.query;

  return aiPageID as string;
};

export const useAIProjectIDFromPath = (): string => {
  const router = useRouter();
  const { ai_project_id: aiProjectID } = router.query;

  return aiProjectID as string;
};
